// src/api/tenant/conversation.js
import { http } from "../base"

export async function loadConversationsByversionNameAndTenantId(versionName, tenantId,keyword, params) {
    console.log("loadConversationsByversionNameAndTenantId(): " + versionName + ", " + tenantId+", "+ keyword);
    console.log("loadConversationsByversionNameAndTenantId(): params={}", params);
    
    return http.get(
        '/aics/conversations/load_messages_by_tenant_and_version',
        {
            params: {
                tenantId: tenantId,
                versionName: versionName,
                keyword: keyword,      // ← 传递关键词
                pageNum: params?.pageNum || 1,
                pageSize: params?.pageSize || 10
            },
            headers: { 'Content-Type': 'application/json' },
            timeout: 100000
        }
    );
}

export async function loadConversationsByPackageNameAndTenantId(packageName, tenantId,keyword, params) {
    console.log("loadConversationsByPackageNameAndTenantId(): " + packageName + ", " + tenantId+", "+ keyword);
    console.log("loadConversationsByPackageNameAndTenantId(): params={}", params);
    
    return http.get(
        '/aics/conversations/load_messages_by_tenant_and_fuel',
        {
            params: {
                tenantId: tenantId,
                packageName: packageName,
                keyword: keyword,      // ← 传递关键词
                pageNum: params?.pageNum || 1,
                pageSize: params?.pageSize || 10
            },
            headers: { 'Content-Type': 'application/json' },
            timeout: 100000
        }
    );
}